import YouTubeIframeLoader from 'youtube-iframe';

class Youtube {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-youtube]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			YouTubeIframeLoader.load(this.loadVideo.bind(this, $scope));
		})
	}

	loadVideo($scope, YT) {
		let youtubeId = $scope.data('youtube');
		let config = {
			height: '1080',
			width: '1920',
			videoId: `${youtubeId}?showinfo=0`,
			playerVars: {
				controls: 0,
				showinfo: 0,
				loop: 0,
				autoplay: 0,
				mute: 1,
				playlist: youtubeId
			},
			events: {}
		};

		if($scope.data('autoplay') == undefined || ['1', 1, true, 'true'].includes($scope.data('autoplay'))) {
			config['events']['onReady'] = this.onReady.bind(this);
			config['autoplay'] = 1;
			config['loop'] = 1;
		}

		new YT.Player($scope[0], config);
	}

	onReady(event) {
		event.target.playVideo();
	}
}

export default Youtube;